import axiosBase from "@/api/axiosBase";

const state = {
    displayType: {}, //用于控制右侧图表是否分组
    displayTypeChangeNum:-1,
    colNum: {}, //用于控制右侧图表的展示列
    colNumChangeNum:-1,
    tjDate:{}, //存放界面用到的统计时间
    tjDateChangeNum:-1,
    currentGroupCate:{}, //存放结果右侧分组当前在时间序列、还是散点或其他组下
    hasSZModel:{}, //是否开水质模块
}

const getters = {
    displayTypeChange: state => state.displayTypeChangeNum,
    colNumChange: state => state.colNumChangeNum,
    tjDateChange: state => state.tjDateChangeNum
}

const actions = {
    //添加收藏夹
    addFavorite({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/favoriate/add',
                data:{
                    "category": data.category,
                    "favor_id": data.favor_id.toString(),
                    "key": data.key,
                    "value": data.value
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取收藏夹列表
    getFavoriteList({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/favoriate/get',
                data:{
                    "category": data.category,
                    "favor_id": data.favor_id != null && data.favor_id != undefined ? data.favor_id.toString() : data.favor_id,
                    "key": data.key
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //删除收藏夹
    deleteFavorite({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/favoriate/del',
                data:{
                    "category": data.category,
                    "favor_id": data.favor_id.toString(),
                    "key": data.key
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取变量列表
    getVariablesParams({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'GET',
                url:'/model_result/allVars?model_id='+data.sceneId + '&obj_type=' + data.type
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取结果展示的子流域/子河道/点源/PSload/PSGroup的ID列表
    getResultDisplayIDList({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'GET',
                url:'/model_result/getIds?model_id='+data.sceneId + '&obj_type=' + data.type
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取统计结果
    getOverview({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model_result/overview',
                data:{
                    "model_id": data.sceneId,
                    "obj_type": data.type,
                    "scale": data.scale
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //统计结果-陆域带HRU统计
    getOverviewWithHRU({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model_result/multi_hru',
                data:{
                    "model_id": data.sceneId,
                    "scale": data.scale,
                    "var": data.columnZB,
                    "hru_ids": data.hruIds
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取统计后时间序列
    getTimeSeries({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model_result/statSeries',
                data:{
                    "model_id": data.sceneId,
                    "start_time": data.stime,
                    "end_time": data.etime,
                    "params": data.params,
                    "scale": data.scale,
                    "obj_type": data.obj_type,
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取时间列表
    getTimes({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model_result/getTimes',
                data:{
                    "model_id": data.sceneId,
                    "obj_type": data.type,
                    "start_time": data.stime,
                    "end_time": data.etime,
                    "scale": data.scale
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取水量平衡
    getWaterBalance({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model_result/waterBalance',
                data:{
                    "model_id": data.sceneId,
                    "scale": data.scale,
                    'ids': data.fIds,
                    'vars': data.fVars
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取污染源统计-总览
    getPopulationTJ({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model_result/pollutionSource',
                data:{
                    "model_id": data.sceneId,
                    "scale": data.scale,
                    'ids': data.fIds,
                    'vars': data.fVars
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取污染源统计-面源
    getPopulationTJ_surf({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model_result/surfaceSource',
                data:{
                    "model_id": data.sceneId,
                    "scale": data.scale,
                    'ids': data.fIds,
                    'vars': data.fVars,
                    "stat_by": data.stat_by,
                    "stat_type": data.stat_type
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取污染源统计-点源
    getPopulationTJ_point({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model_result/pointSource',
                data:{
                    "model_id": data.sceneId,
                    "scale": data.scale,
                    'ids': data.fIds,
                    'vars': data.fVars,
                    "stat_by": data.stat_by,
                    "stat_type": data.stat_type
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取出流排名
    getOutletRank({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model_result/outletRank',
                data:{
                    "model_id": data.sceneId,
                    "scale": data.scale,
                    'ids': data.fIds,
                    'vars': data.fVars,
                     "is_all_outlet": data.is_all_outlet
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //提取out结果
    getResultOut({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model_result/extract_out',
                data:{
                    "model_id": data.sceneId,
                    "sub_ids": data.subids,
                    "ps_ids": data.psids,
                    "ps_group_ids": data.psgroupids,
                    "landuse": data.landuse,
                    "stream": data.stream
                },
                responseType: 'blob'
            }).then(res=>{
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取输出文件名
    getOutIDs({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'GET',
                url:'/model_result/get_out_file_name/'+data.sceneId
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //提取出流排名及汇水区降雨量
    exportOutFlow({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model_result/extract_outlet_rank_and_rainfall',
                data:{
                    "ids": data.ids,
                    "model_id": data.model_id,
                    "scale": data.scale,
                    "vars": data.vars
                },
                responseType: 'blob'
            }).then(res=>{
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    }
}

const mutations = {
    setTJDate(state, tjJson){
        state.tjDate[tjJson.sceneId] = tjJson.tjDate;
        state.tjDateChangeNum += 1;
    },
    setDisplayType(state, jsonStr){
        state.displayType[jsonStr.sceneId] = jsonStr.displayCate;
        state.displayTypeChangeNum += 1;
    },
    setColNum(state, jsonStr){
        state.colNum[jsonStr.sceneId] = jsonStr.colNum;
        state.colNumChangeNum += 1;
    },
    setCurrentGroupCate(state, jsonStr){
        state.currentGroupCate[jsonStr.sceneId] = jsonStr.cate;
    },
    setHasSZModel(state, jsonStr){
        state.hasSZModel[jsonStr.sceneId] = jsonStr.hasSZModel;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}